<script>
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import IconHeart from "@js/components/Icons/IconHeart.vue";
import IconHeartFilled from "@js/components/Icons/IconHeartFilled.vue";
import IconTrash from "@js/components/Icons/IconTrash.vue";
import {useCartStore} from "@js/store/CartStore.js";
import {useLikeStore} from "@js/store/LikeStore.js";
import {ref} from "vue";
import QuantitySelector from "@js/components/Sections/Cart/QuantitySelector.vue";
import {Link} from "@inertiajs/vue3";
import ImageLoader from "@js/components/Loaders/ImageLoader.vue";

export default {
    name: "CartListItem",
    components: {ImageLoader,
        Link,
        QuantitySelector,
        IconTrash,
        IconHeartFilled,
        IconHeart,
        NumberFormatComponent
    },
    props: {
        product: {
            required: true,
        }
    },
    setup(props) {
        const cartStore = useCartStore();
        const likeStore = useLikeStore();

        const qty = ref(cartStore.calculateArea(props.product.length, props.product.width));

        const productFromCart = cartStore.findItem(props.product.id)

        let unit = ref('m2');
        if (productFromCart) {
            unit = ref(productFromCart.unit);
        }

        function onQtyChange(value) {
            qty.value = value;
        }

        function onUnitChange(value) {
            unit.value = value;
        }

        return {
            cartStore,
            likeStore,
            qty,
            unit,
            onQtyChange,
            onUnitChange,
        };
    }
}
</script>

<template>
    <!-- Изображение -->
    <Link :href="route('product', {slug:product.slug})"
          class="border border-white md:hover:border-baseColor max-md:active:border-baseColor md:hover:shadow transition rounded">
        <ImageLoader :title="product.title"
                     :src="product.image_urls[0]"
                     imgClasses="min-w-20 max-w-20 min-h-20 max-h-20 object-cover rounded"/>
    </Link>

    <!-- Информация и управление -->
    <div class="flex-1 ml-4 flex flex-col justify-between">

        <!-- Название, код, бренд/страна -->
        <div>
            <Link :href="route('product', {slug:product.slug})"
                  class="font-medium leading-tight md:hover:text-likeColor transition">
                {{ product.title }}
            </Link>
            <div class="text-sm text-gray-600 mt-1">
                Артикул: {{ product.article ?? 'Н/Д' }}
            </div>
            <div class="flex items-center gap-2 text-sm text-gray-600 mt-1">
                <span class="font-semibold">{{ product.brands_title }}</span>
                <img
                    v-if="product.brands_country_code"
                    :src="'/assets/flags/' + product.brands_country_code +'.svg'"
                    :alt="product.brands_country_code" :title="product.brands_country_code"
                    class="h-3 w-4 rounded object-cover"/>
                <span>{{ product.countries_title }}</span>
            </div>
        </div>

        <!-- Количество + итоговая цена -->
        <div class="mt-4 flex flex-col lg:flex-row lg:items-center max-md:justify-start gap-5">
            <!-- Стандартный селектор количества/единиц -->
            <QuantitySelector
                :key="product.id"
                :product-id="product.id"
                :model-value="cartStore.calculateArea(product.length, product.width)"
                :model-unit="unit"
                :area-per-piece="cartStore.calculateArea(product.length, product.width)"
                :count-in-box="product.count_in_box"
                @update:value="onQtyChange"
                @update:unit="onUnitChange"/>

            <!-- Итоговая цена за эту строку -->
            <div class="lg:ml-auto font-medium">
                Всего:
                <NumberFormatComponent :number="cartStore.getProductTotalPrice(product.id)"
                                       append_text=" ₽" class="font-semibold text-lg"/>
            </div>
        </div>
        <div class="mt-2 flex items-center justify-between text-sm text-gray-500">
            <div>
                <NumberFormatComponent :number="product.price"
                                       :append_text="' ₽/м²'"/>
            </div>
            <div class="flex items-center space-x-3">
                <IconHeart v-if="!likeStore.isLiked(product.id)"
                           @click.prevent="likeStore.toggleLike(product.id)"
                           class="w-6 h-6 text-gray-600 md:hover:text-red-600 cursor-pointer"/>
                <IconHeartFilled v-else @click.prevent="likeStore.toggleLike(product.id)"
                                 class="w-6 h-6 text-red-600 md:hover:text-gray-600 cursor-pointer"/>
                <button @click.prevent="cartStore.remove(product.id)"
                        class="text-red-600/80 md:hover:text-red-600">
                    <IconTrash class="w-6 h-6 transition"/>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
